import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpStatusCode,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ErrorHandlerService } from '../services/error-handler.service';
import { SKIP_NOT_FOUND_HANDLING } from '../tokens/skip-not-found-handling.token';

@Injectable({
    providedIn: 'root',
})
export class HttpErrorInterceptor implements HttpInterceptor {
    private readonly errorHandler = inject(ErrorHandlerService);

    public intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (!(
                    error.status === HttpStatusCode.NotFound &&
                    request.context.get(SKIP_NOT_FOUND_HANDLING)
                )) {
                    this.errorHandler.handleError(error);
                }

                return throwError(() => error);
            })
        );
    }
}
